export const listingDetail = {
  breadcrumb: {
    listings: "Annonces",
    detailFallback: "Détail",
  },
  hero: {
    noName: "Sans nom",
    editNameTitle: "Modifier le nom",
    channelConnected: "Connecté au canal (OTA)",
    channelDisconnected: "Non connecté au canal",
  },
  units: {
    unitsCount: "{count} logements",
    roomsCount: "{count} chambre | {count} chambres",
    maxGuests: "Max. {count} clients",
    searchPlaceholder: "Rechercher un logement…",
    dragTitle: "Glisser pour réorganiser",
    headerRoomTypes: "TYPES DE CHAMBRE",
    headerLinkedUnits: "LOGEMENTS LIÉS",
    addBtnTitle: "Ajouter un logement",
    movedBadge: "déplacé",
    unitFallback: "Logement",
  },
  typeLabels: {
    apartment: "Appartement",
    house: "Maison",
    villa: "Villa",
    hotel: "Hôtel",
    room: "Chambre",
    studio: "Studio",
    fallback: "Hébergement",
  },
  aiReception: {
    title: "Réception IA",
  },
  toggles: {
    enableAgent: {
      label: "Activer l'agent IA",
      hint: "Automatisez l'assistance client sur WhatsApp.",
    },
    otaAgent: {
      label: "Agent IA pour les OTA",
      hintOn: "Répond aussi aux messages de Booking, Airbnb et d'autres OTA.",
      hintOff: "Nécessite que l'agent IA soit actif.",
    },
  },
  status: {
    active: "Actif",
    inactive: "Inactif",
  },
  emptyUnits: {
    title: "Aucun logement",
    subHotel: "Créez la première chambre ou le premier logement de cet hôtel pour commencer à configurer les tarifs et les disponibilités.",
    subDefault: "Ajoutez le premier logement à cette annonce pour commencer à recevoir des clients.",
    ctaPreparing: "Préparation…",
    ctaAddRoom: "Ajouter une chambre",
    ctaAddFirstUnit: "Ajouter le premier logement",
  },
  sortBar: {
    add: "Ajouter",
    addRoom: "Ajouter une chambre",
    saving: "Enregistrement…",
    done: "Terminé",
    sort: "Réorganiser",
    dragHint: "Glisser pour réorganiser",
  },
  propOptions: {
    scheduled: "Messages programmés",
    services: "Équipements et commodités",
    locks: "Serrures",
    faq: "Questions/Réponses",
    arrival: "Instructions d'arrivée",
    checkout: "Message de check-out",
    welcome: "Message de bienvenue",
    description: "Description",
    capacity: "Capacité",
  },
  addZone: {
    titleRoom: "Ajouter une chambre",
    titleUnit: "Ajouter un logement",
    roomLower: "chambre",
    unitLower: "logement",
    createNew: "Créer un nouveau {noun} à l'intérieur",
    eachHas: "Chaque {noun} a ses propres paramètres (description, capacité, accès…).",
    ctaPreparing: "Préparation…",
    ctaCreateRoom: "Créer la chambre",
    ctaCreateUnit: "Créer le logement",
  },
  danger: {
    deleteListing: "Supprimer l'annonce...",
    notePrefix: "Supprime l'annonce",
    noteSuffix: " et tous ses logements de WACheckin. Cette action est irréversible.",
  },
  toast: {
    orderSaved: "Ordre enregistré avec succès",
  },
  errors: {
    loadListing: "Impossible de charger l'hébergement.",
  },
  authorities: {
    title: "Autorités",
    description: "Configurez la connexion avec les autorités locales pour la déclaration automatique de l'enregistrement des clients.",
  },
  cards: {
    knowledge: { title: "Base de connaissances", status: "Informations utilisées par l'agent" },
    earlyAccess: { title: "Arrivée anticipée", status: "Heures d'arrivée et check-in anticipé" },
    lateCheckout: { title: "Check-out tardif", status: "Check-out tardif et prix" },
    extendStay: { title: "Prolonger le séjour", status: "Prolonger les nuits de la réservation" },
    invoicing: { title: "Facturation", status: "Données fiscales · compatible Verifactu" },
    location: { title: "Emplacement", sub: "Adresse de l'hébergement" },
    logo: { title: "Image de marque", sub: "Identité visuelle" },
    welcome: { title: "Message de bienvenue", sub: "Personnalisez l'accueil" },
    checkin: { title: "Check-in", sub: "Instructions et horaires d'entrée" },
    policies: { title: "Politiques de l'hébergement", sub: "Règles et conditions" },
    authorities: { sub: "Enregistrement auprès des autorités" },
    hotelRates: { title: "Tarifs de l'hôtel", sub: "Tarifs de base et dérivés" },
    roomManagement: { title: "Chambres", sub: "Types de chambre et inventaire" },
    rates: { title: "Tarifs", sub: "Tarifs de base et dérivés" },
    ota: { title: "Connecter une OTA", subPaid: "Booking · Airbnb · Vrbo · Expedia", subUnpaid: "Nécessite un abonnement actif" },
    ical: { title: "Calendrier iCal", sub: "Synchronisation du calendrier" },
    ownerSettlement: { title: "Propriétaire et reversements", sub: "Si vous le gérez pour un autre propriétaire : commission et reversements", subManaged: "Géré pour {owner} · {pct}\u00a0%", subManagedNoOwner: "Géré · {pct}\u00a0% · aucun propriétaire attribué" },
    otaCommissions: { title: "Commissions des OTA", sub: "Ce que garde chaque OTA et ce que vous recevez", subActive: "La fiche affiche ce que vous recevez de chaque réservation" },
    description: { title: "Description", sub: "Détails du logement" },
    capacity: { title: "Capacité", sub: "Clients et lits" },
    services: { title: "Équipements et commodités", sub: "Ce qu'il offre, avec photos" },
    unitFaq: { title: "Questions/Réponses", sub: "Spécifiques à ce logement pour l'agent" },
    rules: { title: "Horaires", sub: "Heures de check-in et de check-out" },
    upselling: { title: "Expériences et services", sub: "Services d'upselling" },
    checkinStore: { title: "Boutique du check-in", sub: "Envoyez-la au voyageur à l'arrivée" },
    bookingConfirmation: { title: "Notifier une nouvelle réservation", sub: "Nous informons le client sur WhatsApp lorsque sa réservation est confirmée" },
    arrivalInstructions: { title: "Instructions d'arrivée", sub: "Comment s'y rendre et entrer · avec heure d'envoi" },
    checkoutMessage: { title: "Message de check-out", sub: "Rappel de check-out · modèle" },
    scheduledMessages: { title: "Messages programmés", sub: "Messages automatiques avant, pendant et après le séjour" },
    review: { title: "Demander un avis", sub: "Réputation de l'hébergement" },
    identity: { title: "Vérification d'identité", sub: "Sécurité des clients" },
    journeySim: { title: "Simuler le parcours client", sub: "Rejoue tout le processus sur WhatsApp · envoyez-le à un téléphone pour tester" },
    smartlocks: { title: "Serrures et accès", sub: "Comment le client entre" },
    integrations: { title: "Connexions et intégrations", sub: "API et connexions supplémentaires" },
    welcomeInline: { sub: "Message spécifique à ce logement" },
    newBookings: { title: "Nouvelles réservations" },
  },
  badges: {
    ai: "IA",
    setup: "Configuration",
    hotel: "Hôtel",
    subscription: "Abonnement",
    comingSoon: "Bientôt disponible",
    test: "Test",
    manager: "Gestionnaire",
    active: "Actif",
  },
  sections: {
    essential: { title: "Configuration essentielle", description: "Paramètres de base nécessaires pour publier et gérer l'hébergement." },
    management: { title: "Gestion de l'hébergement", description: "Configurez les tarifs, les disponibilités et les canaux de vente." },
    direct: { title: "Détailler ce logement", description: "Informations supplémentaires que nous utilisons pour les réservations directes et pour alimenter l'agent IA." },
    guest: { title: "Expérience client", description: "Configurez la communication avant, pendant et après le séjour." },
    access: { title: "Accès et intégrations", description: "Gérez les accès, les serrures et les connexions externes." },
  },
  otaModal: {
    title: "Connexion OTA",
    html: "La connexion de Booking, Airbnb, Vrbo, Expedia (channel manager) nécessite un <b>abonnement actif</b>.<br><small>En attendant, vous pouvez utiliser les autres fonctionnalités et synchroniser les calendriers via iCal (gratuit).</small>",
    confirm: "Activer l'abonnement",
    cancel: "Pas maintenant",
  },
};
